const seventhSlider = document.getElementById("seventh-slider");
const seventhTrack = seventhSlider.querySelector("ul");

// Duplicar contenido
seventhTrack.innerHTML += seventhTrack.innerHTML + seventhTrack.innerHTML;

setTimeout(() => {
  seventhSlider.scrollLeft = seventhTrack.scrollWidth / 3;
}, 50);

let isDraggingSeventh = false;
let startXSeventh;
let scrollLeftSeventh;
let velocitySeventh = 0;
let lastMoveSeventh = 0;
let lastTimeSeventh = 0;
let seventhFrame;

let isPausedSeventh = false;

seventhSlider.addEventListener("mouseenter", () => {
  isPausedSeventh = true;
});

seventhSlider.addEventListener("mouseleave", () => {
  isPausedSeventh = false;
  isDraggingSeventh = false;
  seventhSlider.style.cursor = 'grab';
});

seventhSlider.addEventListener("mousedown", (e) => {
  isDraggingSeventh = true;
  startXSeventh = e.pageX - seventhSlider.offsetLeft;
  scrollLeftSeventh = seventhSlider.scrollLeft;
  velocitySeventh = 0;
  cancelAnimationFrame(seventhFrame);
});

seventhSlider.addEventListener("mouseup", () => {
  isDraggingSeventh = false;
  seventhSlider.style.cursor = 'grab';

  const momentum = () => {
    if (Math.abs(velocitySeventh) < 0.1) return;
    seventhSlider.scrollLeft -= velocitySeventh;
    velocitySeventh *= 1;
    seventhFrame = requestAnimationFrame(momentum);
  };
  momentum();
});

seventhSlider.addEventListener("mousemove", (e) => {
  if (!isDraggingSeventh) return;
  e.preventDefault();

  const now = Date.now();
  const x = e.pageX - seventhSlider.offsetLeft;
  const dx = x - startXSeventh;
  seventhSlider.scrollLeft = scrollLeftSeventh - dx;

  velocitySeventh = (x - lastMoveSeventh) / (now - lastTimeSeventh + 1);
  lastMoveSeventh = x;
  lastTimeSeventh = now;
});

// 👉 Touch support (exactamente como el slider 6)
seventhSlider.addEventListener("touchstart", (e) => {
  isDraggingSeventh = true;
  startXSeventh = e.touches[0].pageX - seventhSlider.offsetLeft;
  scrollLeftSeventh = seventhSlider.scrollLeft;
  cancelAnimationFrame(seventhFrame);
}, { passive: true });

seventhSlider.addEventListener("touchmove", (e) => {
  if (!isDraggingSeventh) return;
  const x = e.touches[0].pageX - seventhSlider.offsetLeft;
  const dx = x - startXSeventh;
  seventhSlider.scrollLeft = scrollLeftSeventh - dx;
}, { passive: true });

seventhSlider.addEventListener("touchend", () => {
  isDraggingSeventh = false;
});

// Auto-scroll a la IZQUIERDA (como querías)
function autoScrollSeventh() {
  if (!isPausedSeventh && !isDraggingSeventh) {
    seventhSlider.scrollLeft -= 1;
    const third = seventhTrack.scrollWidth / 3;
    if (seventhSlider.scrollLeft <= third) {
      seventhSlider.scrollLeft = third * 2;
    }
  }
  setTimeout(autoScrollSeventh, 30);
}

autoScrollSeventh();
